import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
const finalComparison = [{
  sin: '20+ horas buscando planos en internet por proyecto',
  con: 'Lista de corte lista en 10 minutos'
}, {
  sin: 'Tableros tirados a la basura por errores de cálculo',
  con: 'Protocolo 1 Tablero: cero desperdicio'
}, {
  sin: 'Mecanismos que fallan a los 3 meses',
  con: 'Herraje correcto para cada carga y uso'
}, {
  sin: 'Presupuestos que no cierran por miedo al precio',
  con: 'Sistema en 3 niveles que justifica solo'
}, {
  sin: 'Instalaciones que se aflojan con el tiempo',
  con: 'Protocolo de anclaje anti-vibración documentado'
}, {
  sin: 'Sin material diferenciado por tipo de proyecto',
  con: '6 tomos con progresión → el cliente ve la diferencia'
}, {
  sin: 'Cotizaciones que tardás 2 días en hacer',
  con: 'Calculadora: precio en 3 minutos'
}, {
  sin: 'Reclamos por muebles que se caen de la pared',
  con: 'Prueba de carga y garantía documentada'
}, {
  sin: 'Sin saber cuánto cobrar cuando tenés ayudante',
  con: 'Fórmula de escala con margen calculado'
}, {
  sin: 'Fabricar 1 mueble cada 3 días',
  con: 'Sistema de lotes: 5 muebles en la misma semana'
}];
export function ComparisonTable() {
  return <section className="py-24 bg-cream-dark" data-id="element-40">
      <div className="container mx-auto px-4" data-id="element-41">
        <div className="text-center max-w-4xl mx-auto mb-16" data-id="element-42">
          <h2 className="text-3xl md:text-4xl font-bold text-wood-dark mb-6" data-id="element-43">
            El próximo fin de semana podés seguir calculando medidas a ojo.
          </h2>
          <p className="text-2xl font-serif text-amber-dark font-black" data-id="element-44">
            O podés tener todo resuelto desde hoy.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-5xl mx-auto bg-white rounded-2xl shadow-warm overflow-hidden border border-wood-light/20" data-id="element-45">
          <div className="p-6 bg-wood-dark text-center" data-id="element-46">
            <h3 className="text-2xl font-bold text-cream" data-id="element-47">
              ¿Cuánto cuesta NO tenerlo?
            </h3>
          </div>

          <div className="overflow-x-auto" data-id="element-48">
            <table className="w-full text-left border-collapse min-w-[700px]" data-id="element-49">
              <thead data-id="element-50">
                <tr data-id="element-51">
                  <th className="p-6 bg-red-50 text-red-900 font-bold border-b-2 border-red-200 w-1/2 text-center text-lg" data-id="element-52">
                    Sin Super Combo Carpintería Plegable PRO
                  </th>
                  <th className="p-6 bg-green-50 text-green-900 font-bold border-b-2 border-green-200 w-1/2 text-center text-lg" data-id="element-53">
                    Con Super Combo Carpintería Plegable PRO
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-54">
                {finalComparison.map((row, index) => <tr key={index} className="border-b border-wood-light/10" data-id="element-55">
                    <td className="p-4 md:p-6 text-red-800/80 flex items-start" data-id="element-56">
                      <XCircle className="w-5 h-5 text-red-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-57" />
                      {row.sin}
                    </td>
                    <td className="p-4 md:p-6 text-green-900 font-medium bg-green-50/30 flex items-start h-full" data-id="element-58">
                      <CheckCircle2 className="w-5 h-5 text-green-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-59" />
                      {row.con}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </motion.div>
      </div>
    </section>;
}